import { render, staticRenderFns } from "./touchDetail.vue?vue&type=template&id=ff62d09a&scoped=true"
import script from "./touchDetail.vue?vue&type=script&lang=js"
export * from "./touchDetail.vue?vue&type=script&lang=js"
import style0 from "./touchDetail.vue?vue&type=style&index=0&id=ff62d09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff62d09a",
  null
  
)

export default component.exports